import styled from '@emotion/styled';
import {
  typography,
  space,
  layout,
  color,
  border,
  alignItems,
  justifyContent,
  position,
  zIndex,
  shadow,
  borders,
  flex,
  flexWrap,
  backgroundImage,
  backgroundSize,
  backgroundPosition,
  backgroundRepeat,
} from 'styled-system'

const Box = styled('div')(
  typography,
  space,
  layout,
  color,
  border,
  alignItems,
  justifyContent,
  position,
  zIndex,
  shadow,
  borders,
  flex,
  flexWrap,
  backgroundImage,
  backgroundSize,
  backgroundPosition,
  backgroundRepeat,
);

export default Box;
